import React, { useState, useEffect } from 'react';

import {
  Stack,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  FormHelperText,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector } from 'react-redux';

export default function VolumeField({
  index,
  value,
  error,
  setValue,
  setError,
  remove,
}) {
  const [volumeId, setVolumeId] = useState(value ? value.volume_id || value.id : '');

  const volumes = useSelector((state) => state.volumes);

  useEffect(() => {
    setVolumeId(value?.volume_id || value?.id || '');
  }, [value]);

  useEffect(() => {
    if (!volumeId) return;

    const activeList = volumes || [];
    const exists = activeList.some((v) => v.id === volumeId);

    if (!exists) {
      setError(index, 'Volume missing or deleted');
      return;
    }

    if (error === 'Volume missing or deleted') {
      setError(index, false);
    }
  }, [volumeId, volumes, index, setError, error]);

  const handleChange = (event, val) => {
    const newId = val ? val.props.value : event.target.value;
    setVolumeId(newId);

    // Find the selected volume to get its name
    const selectedVolume = volumes?.find((v) => v.id === newId);

    if (selectedVolume) {
      setValue(index, {
        volume_id: newId,
        id: newId,
        name: selectedVolume.name,
      });
      setError(index, false);
    } else {
      setValue(index, {
        volume_id: newId,
        id: newId,
      });
      if (newId === '') {
        setError(index, 'Volume cannot be blank');
      } else {
        setError(index, 'Volume missing or deleted');
      }
    }
  };

  const availableVolumes = volumes || [];

  return (
    <Stack
      direction='row'
      justifyContent='flex-start'
      alignItems='center'
      spacing={1}
    >
      <Box sx={{ minWidth: '300px' }}>
        <FormControl fullWidth required>
          <InputLabel id={`volume-${index}-label`}>Volume</InputLabel>
          <Select
            labelId={`volume-${index}-label`}
            id={`volume-${index}`}
            value={volumeId}
            label='Volume'
            onChange={handleChange}
            aria-describedby={`volume-${index}-helper-text`}
          >
            {availableVolumes.map((volume) => {
              return (
                <MenuItem
                  key={volume.id}
                  value={volume.id}
                  name={volume.name}
                >
                  {volume.name}
                </MenuItem>
              );
            })}
          </Select>
          {error ? (
            <FormHelperText id={`volume-${index}-helper-text`}>
              {error}
            </FormHelperText>
          ) : undefined}
        </FormControl>
      </Box>
      <IconButton
        onClick={() => {
          remove(index);
        }}
      >
        <DeleteIcon />
      </IconButton>
    </Stack>
  );
}

